<template>
  <div class="relative">

    <div class="vx-navbar-wrapper" :class="classObj">

      <vs-navbar
        class="vx-navbar navbar-custom navbar-skelton"
        :color="navbarColorLocal"
        :class="textColor"
      >

        <!-- SM - OPEN SIDEBAR BUTTON -->
        <feather-icon
          class="sm:inline-flex xl:hidden cursor-pointer p-2"
          icon="MenuIcon"
          @click.stop="showSidebar"
        />

        <vs-spacer />

        <back-original-user v-if="!isOriginalUser" />

<!--        <search-bar />-->

        <!-- <vs-switch class="mr-8" v-model="userStatus">
          <span slot="on">Conectado</span>
          <span slot="off">Desconectado</span>
        </vs-switch>

        <trasferrer-drop-down />

        <notification-drop-down />

        <profile-drop-down /> -->

      </vs-navbar>
    </div>
  </div>
</template>


<script>
  import ProfileDropDown      from "./components/ProfileDropDown.vue"
  import BackOriginalUser     from "./components/BackOriginalUser.vue"
  import NotificationDropDown from "./components/NotificationDropDown.vue"
  import TrasferrerDropDown   from "./components/TrasferrerDropDown.vue"
  import { getIp } from '@/utils'

  import moduleUser from '@/store/user/moduleUser.js'

  import user from '@/http/requests/user'

  export default {
    name: "the-navbar-vertical",
    props: {
      navbarColor: {
        type: String,
        default: '#fff'
      }
    },
    data() {
      return {
        userStatus: false
      }
    },
    watch: {
      async userStatus(val) {
        const ip = await getIp();
        if (val) {
          return user.connected(ip)
        }

        return user.disconnected(ip)
      }
    },
    components: {
      ProfileDropDown,
      BackOriginalUser,
      NotificationDropDown,
      TrasferrerDropDown
    },
    computed: {
      navbarColorLocal() {
        if (this.$store.state.theme === "dark" && this.navbarColor === "#fff") {
          return '#10163a'
        }

        return this.navbarColor
      },
      verticalNavMenuWidth() {
        return this.$store.state.verticalNavMenuWidth
      },
      textColor() {
        return {
          'text-white': (this.navbarColor !== '#10163a' && this.$store.state.theme === 'dark')
                  || (this.navbarColor !== '#fff' && this.$store.state.theme !== 'dark')
        }
      },
      windowWidth() {
        return this.$store.state.windowWidth
      },
      // NAVBAR STYLE
      classObj() {
        if (this.verticalNavMenuWidth === 'default') {
          return "navbar-default"
        }

        if (this.verticalNavMenuWidth === 'reduced') {
          return "navbar-reduced"
        }

        if (this.verticalNavMenuWidth) {
          return "navbar-full"
        }
      },
      isOriginalUser() {
        return this.$store.state.user.isOriginalUser
      }
    },
    created() {
      const that = this
      if (!moduleUser.isRegistered) {
        this.$store.registerModule('user', moduleUser)
        moduleUser.isRegistered = true
      }

      this.$store.dispatch("user/infos").then(() => {
        const userInfo = JSON.parse(localStorage.getItem("userInfo"))
        that.userStatus = userInfo.isConnected
      })
    },
    methods: {
      showSidebar() {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
      }
    }
  }
</script>

